import { ReferenceMeasure } from "@domain/project/floorplan/reference-measure";
import { ReferenceMeasureRow } from "@pdf/export-services/product-information-pages/floorplan-information-pages/reference-measure/reference-measure-row";
import { TableColumn } from "@pdf/helpers/default-table/table-column";
import { Headlines, ImagePaths, TableProperties } from "@pdf/pdf-properties";
import { jsPDF } from "jspdf";
import { FloorplanInformationTable } from "../floorplan-information-table";

export class ReferenceMeasureRowHeaders {
  public readonly NUMBER: string = $localize`:@@pdfExport.referenceMeasureTable.header.number:Nr.`;
  public readonly DISPLAY_NAME: string = $localize`:@@pdfExport.referenceMeasureTable.header.displayName:Anzeigename`;
  public readonly SCALE: string = $localize`:@@pdfExport.referenceMeasureTable.header.text:Referenzmaß`;
  public readonly UNIT: string = $localize`:@@pdfExport.referenceMeasureTable.header.unit:Einheit`;
  public readonly NOTES: string = $localize`:@@pdfExport.referenceMeasureTable.header.notes:Notizen`;
}

export class ReferenceMeasureTable extends FloorplanInformationTable {
  public readonly UNIT_VALUE: string = $localize`:@@pdfExport.referenceMeasureTable.header.unitMeter:Meter`;
  readonly headlines = new Headlines();
  readonly rowHeaders = new ReferenceMeasureRowHeaders();
  override readonly headline = this.headlines.REFERENCE_MEASURE;
  override readonly columns: TableColumn[];
  override readonly rows: ReferenceMeasureRow[];

  constructor(pdf: jsPDF, referenceMeasure: ReferenceMeasure) {
    super(ImagePaths.MEASUREMENT_LINE);
    this.columns = [
      new TableColumn(this.rowHeaders.NUMBER, 60, 96),
      new TableColumn(this.rowHeaders.DISPLAY_NAME, 180, 156),
      new TableColumn(this.rowHeaders.SCALE, 360, 180),
      new TableColumn(this.rowHeaders.UNIT, 520, 146),
      new TableColumn(this.rowHeaders.NOTES, 690, 750),
    ];

    this.rows = [
      new ReferenceMeasureRow(
        pdf,
        this.textToColumnWidth(
          pdf,
          TableProperties.TEXT_FONT_SIZE,
          this.preProcessText(referenceMeasure.positionId),
          this.rowHeaders.NUMBER,
        ),
        this.textToColumnWidth(
          pdf,
          TableProperties.TEXT_FONT_SIZE,
          this.preProcessText(referenceMeasure.displayName),
          this.rowHeaders.DISPLAY_NAME,
        ),
        this.textToColumnWidth(
          pdf,
          TableProperties.TEXT_FONT_SIZE,
          this.preProcessText(referenceMeasure.scale.toString()),
          this.rowHeaders.SCALE,
        ),
        this.textToColumnWidth(pdf, TableProperties.TEXT_FONT_SIZE, this.preProcessText(this.UNIT_VALUE), this.rowHeaders.UNIT),
        this.textToColumnWidth(
          pdf,
          TableProperties.TEXT_FONT_SIZE,
          this.preProcessText(referenceMeasure.notes),
          this.rowHeaders.NOTES,
        ),
      ),
    ];

    this.height = this.calculateHeight(this.rows);
  }
}
